// libraries, constants, and class definitions
import { EBADF } from "constants";
import * as createjs from "createjs-module";
import * as symConst from 'src/app/shared/constant/canvasSymTypes'; 
import {DISPLAY_TYPE_GRID, DISPLAY_TYPE_LINE, DISPLAY_TYPE_TEXT, SIZE,  START_XPOS, START_YPOS, 
        SIZE,  CanvasInput,LINE_COLOR} from 'src/app/shared/constant/drawConstants';
import { STATE_NORMAL, STATE_OPEN_FILE, STATE_INIT,STATE_IN_IPAD_ABC,STATE_IN_CLIPBOARD_SELECT,
  STATE_IN_GRID_FRACTION_NUM, STATE_IN_GRID_FRACTION_DEN, 
    MLineType, SymbolSimple, OverlayType,OVERLAY_TYPE_LINE,STATE_IN_PASTE,
    OVERLAY_TYPE_DIVIDE,STATE_CARRY_SYM} from 'src/assets/js/cv-classes.js';

// functions and varibles
import { drawProbShapes, makeProbSelected,
  drawCursor, drawNewLineSym,drawUpdatedOverlay,drawCrossOff,
  makeNewLineSegment,drawOneSetLineSegment } from 'src/assets/js/cv-graphics-mouse.js';
import { getSymFont,findProbEndX, findProbEndY,findNextPIndex,removeChildFromStage,
  doStageUpdate,checkLev3Mode} from 'src/assets/js/cv-helpers.js';
import {startMProb, drawOneSymText,drawCarryText,insertSymLine, deleteProb} from 'src/assets/js/cv-layout-shared.js';
import {db,stage,draw,cvControl, clearProbState,notifySideboardLev3Mode} from 'src/assets/js/draw.js';


// the one in layout-shared is used, not this one
export function resizeProbGridChange() {

  let oldGridW = db.curProb.gridW;
  let oldFontSize = db.curProb.fontSize;
  //db.initSize(newFontSize);
  let scale = db.gridWidth/oldGridW;
  db.curProb.probScale = scale;
  db.curContainer.scaleX = db.curContainer.scaleY = scale;
  doStageUpdate();
}


/***
 * function newGridSym is called from draw within canvas draw to draw the current keyID
 * symbol into the current x,y position.  It is the highest level routine of the grid management system,
 * and has a lot of complexity in details due to having to deal with subtle differences of how sIndex will
 * show up and be used, depending on whether writing at the end of a grid line, over an existing symbol, or
 * over a null character (entered for space filling)
 */

export function newGridSym(keyID, groupCode, typeCode) {
  //console.log("check line", db.curLine);


  // first time any symbol is drawn to the canvas, set the state to active/normal
  if (db.state == STATE_INIT) {
    db.state = STATE_NORMAL; // this may need setting extra places
  }


  // check if this is over a fill space as part of a grid problem, and is, then don't draw anything
  if (db.curLine.sym[db.curLine.sIndex+1] != null &&
    (db.curLine.sym[db.curLine.sIndex+1].type == symConst.CV_TEXT_FILL )) {
    return;
  }     
    
  // If within a grid fraction, handle that as a special case layout
  // return out of routine unless abc was clicked
  
  if (db.curProb.fracState == STATE_IN_GRID_FRACTION_NUM ||
    db.curProb.fracState == STATE_IN_GRID_FRACTION_DEN) {
      drawGridFraction(keyID,typeCode);
      return;
    }

  // for level 3 grids, set tabs to even grid spaces, so do nothing on others
  if (keyID == symConst.KEY_ID_TAB) {
    if (db.curLine.sIndex % 2 != 0) {
      keyID = symConst.KEY_ID_SPACE;
    }
    else {
      return;
    }
  }
  else if (keyID == symConst.KEY_ID_TAB_EQUAL) {
    // only do tab equals in grid problems (lev 3) if at end of line, otherwise do nothing
    // return after a tab equals to make rest of routine simpler
    if (db.curLine.sIndex == db.curLine.sym.length-1 && db.curProb.tabEqualPos != 0) {
      for (let i = db.curLine.sIndex; i < db.curProb.tabEqualPos-1; i++) {
        pushOneNullSym();
        db.curLine.sIndex++;
        db.xpos += db.curProb.gridW;
      }
      drawCursor(db.xpos-db.curProb.halfGW, db.ypos-db.curProb.halfGH);
    }
    return;
  }


  
    //  if new fraction symbol, not within existing fraction, switch to line symbole
    if (keyID == symConst.KEY_ID_FRACTION) {
      keyID = symConst.KEY_ID_FRACTION_GRID_SIGN;
    }
  
    // figure out the right font for this symbol
      let noLastSymLineSeg = true;
      let symFont = getSymFont(keyID, typeCode);
      let symLength = keyID.length;
      let saveDot = null;
      // Manage line segment ends
      if (db.curLine.sym[db.curLine.sIndex+1] != null) {
        noLastSymLineSeg = (db.curLine.sym[db.curLine.sIndex+1].lineSeg == null); 
        if (!noLastSymLineSeg) {
          saveDot = db.curLine.sym[db.curLine.sIndex+1].lineSegStart;
          db.curLine.sym[db.curLine.sIndex+1].lineSegStart = null;

        }
         
      }
    
    // check for possibility that this is on a null (space-filled) grid spot, 
    // if so just write values into existing sym object without moving anything in the problem
    // sIndex points to position before cursor, so next position to write in is sIndex+1  
    // null (CV_EMPTY_SYM) grid boxes are created to fill columns or rows when the user clicks on
    // a grid problem square that creates a sparesly spaced grid of symbols 
    // exclude the start of ABC text in grid that also has a null str value
    // treat blank spaces the same as nulls
 
   
    if (db.curLine.sym[db.curLine.sIndex+1] != null &&
        ((db.curLine.sym[db.curLine.sIndex+1].str == symConst.CV_EMPTY_SYM ||
          db.curLine.sym[db.curLine.sIndex+1].str == symConst.KEY_ID_SPACE && 
          db.curLine.sym[db.curLine.sIndex+1].crossOff == null) &&
          db.curLine.sym[db.curLine.sIndex+1].type != symConst.KEY_ID_ABC )) {

          if (db.curLine.sym[db.curLine.sIndex+1].str == symConst.KEY_ID_SPACE &&
            db.curLine.sym[db.curLine.sIndex+1].displayText != null) {
              db.curProb.container.removeChild(db.curLine.sym[db.curLine.sIndex+1].displayText);
            }

         
        db.curLine.sym[++db.curLine.sIndex].str = keyID;
        db.curLine.sym[db.curLine.sIndex].type = typeCode;
        //console.log("HereS", db.curLine.lineWidth,db.curLine.sIndex);
        if (db.curLine.lineWidth <= db.curLine.sIndex) {
          db.curLine.lineWidth = db.curLine.sIndex+1;
          if (db.curProb.width < db.curLine.lineWidth) {
            db.curProb.width = db.curLine.lineWidth;

            // update the grid box around the problem if the problem grew in width,
          if (db.state != STATE_OPEN_FILE || db.curLine.sIndex >= db.curProb.widthFromFile-1 || 
                                            db.curProb.widthFromFile == 0) {
              drawProbShapes(Math.max(db.curProb.width+1,2),db.curProb.line.length);
          } 
          }
          //console.log("updated linewidth", db.curLine.lineWidth, db.curProb.width);
        }
    }
    // otherwise create a new symbol object for this symbol in current line and math problem, and assign symbol value and type
    else { 
      let newSym = new SymbolSimple(keyID, typeCode); // change this to support different symbol types
    
      // if at the end of the line, a new line, or during during an open file, then next symbol gets added to 
      // next position in db.curLine
      if (++db.curLine.sIndex == db.curLine.sym.length  || db.state == STATE_OPEN_FILE 
          || db.curLine.sym.length < 1 ) {
          db.curLine.sym[db.curLine.sIndex] = newSym;
          
      }
      // Otherwise, if inserting the middle of a line of symbols, then splice symbol into symbol array 
      else {
        // mover the symbols to the right of the current position over one grid to make room 
        moveOverGridText(db.curLine, db.curLine.sIndex,db.curProb.gridW); 
        db.curLine.sym.splice(db.curLine.sIndex,0,newSym); 

        //console.log("do insert");
        // check if this is an insert into a middle of a line segment associated, if
        // so then add a line segment to this new symbol if it doesn't have one already
        if (!noLastSymLineSeg && db.curLine.sym[db.curLine.sIndex].lineSeg == null) {
          drawOneSetLineSegment(db.curLine,(db.curProb.lIndex+1)*db.curProb.gridH, 
            db.curLine.sIndex,db.curLine.sIndex,LINE_COLOR);
            db.curLine.sym[db.curLine.sIndex].lineSegStart = saveDot;
        }
      }
      // check if need to adjust the problem width, if this is the longest line in the problem 
      if (db.curLine.sym.length > db.curProb.width) {
          db.curProb.width = db.curLine.sym.length;
      }
      
      // update the grid box around the problem, but if doing an open file
      // then only draw the shapes for the last symbol of each problem
      if (db.state != STATE_OPEN_FILE || db.curLine.sIndex >= db.curProb.widthFromFile-1 || 
                                            db.curProb.widthFromFile == 0) {
          drawProbShapes(Math.max(db.curProb.width+1,2),db.curProb.line.length);
      } 
    }
        
    // set up a createjs object to draw this symbol
    if (typeCode == symConst.CV_EQUALS_INQ_TYPE) {
      if (db.userPrefs.alignEqualSign && db.curProb.tabEqualPos != 0 && db.curLine.sIndex == db.curLine.sym.length-1) {
        if (db.curLine.sIndex < db.curProb.tabEqualPos) {
          for (let i = db.curLine.sIndex; i < db.curProb.tabEqualPos; i++) {
            pushOneNullSym();
            db.curLine.sIndex++;
            db.xpos += db.curProb.gridW;
          }
        }
        else {
          db.curProb.tabEqualPos = db.curLine.sIndex;
        }
      }
      else {
        db.curProb.tabEqualPos = db.curLine.sIndex;
      }
    }

    let text = drawOneSymText(keyID, symFont, symLength,typeCode);
    db.curLine.sym[db.curLine.sIndex].displayText = text;

    // if just received new fraction symbol, set state for next character entry 
    if (keyID == symConst.KEY_ID_FRACTION_GRID_SIGN) {
      db.curProb.fracState = STATE_IN_GRID_FRACTION_NUM;
    }
    else {
      // adjust x position over 1 grid for grid problems, unless within fraction   
      db.xpos += db.curProb.gridW;
    }

    drawCursor(db.xpos-db.curProb.halfGW, db.ypos-db.curProb.halfGH);
    //console.log("check line", db.curLine);
  
}


/**
 * function drawGridFraction deals with the special case of drawing a grid fraction - based on state
 */

function drawGridFraction(keyID,typeCode,isDelete) {
  //console.log(typeCode, keyID);

  // first check if new keyID is an allowed symbol within grid fraction
  // not then throw it out, or deal with abc key clicks by exiting fraction
  if (typeCode == symConst.CV_FRACTION_TYPE || typeCode == symConst.CV_DIV_SQRT_TYPE ||
    typeCode == symConst.CV_LINE_TYPE || typeCode == symConst.CV_CROSSOFF_TYPE ||
    keyID == symConst.KEY_ID_TAB || keyID == symConst.KEY_ID_TAB_EQUAL) {
      // do nothing, just return
    }
 
  else {
    // deal with each half of the grid fraction
    if (db.curProb.fracState == STATE_IN_GRID_FRACTION_NUM) {
      
      db.curLine.sym[db.curLine.sIndex].fractionNumStr = 
        drawGridFractionPart(keyID, db.curLine.sym[db.curLine.sIndex].fractionNumStr,
                db.curLine.sym[db.curLine.sIndex].fractionNum,isDelete,typeCode);
      
      if (db.curLine.sym[db.curLine.sIndex].fractionNumStr.length > 2) {
        db.curProb.fracState = STATE_IN_GRID_FRACTION_DEN;
      }
      
    }
    else if (db.curProb.fracState == STATE_IN_GRID_FRACTION_DEN) {
      
      db.curLine.sym[db.curLine.sIndex].fractionDenStr = 
          drawGridFractionPart(keyID, db.curLine.sym[db.curLine.sIndex].fractionDenStr,
                          db.curLine.sym[db.curLine.sIndex].fractionDen,isDelete,typeCode);
      if (db.curLine.sym[db.curLine.sIndex].fractionDenStr.length > 2) {
        db.curProb.fracState = STATE_NORMAL;
        db.xpos += db.curProb.gridW;
      }
    }
    drawCursor(db.xpos-db.curProb.halfGW, db.ypos-db.curProb.halfGH);
  }
}

function drawGridFractionPart(keyID,fractionStr, fractionObj, isDelete,typeCode) {

    if (fractionStr.length > 0) {
      db.curContainer.removeChild(fractionObj);
    }
    // remove the last character if it is a delete
    if (isDelete) {
      fractionStr = fractionStr.substring(0,fractionStr.length-1);
    }
    else {
      // otherwise add the newly entered digit into the fraction string
      fractionStr = fractionStr + keyID;
    }
    // draw the fracton string
    if (fractionStr.length > 0) {
      let symFont = getSymFont(fractionStr[0], symConst.CV_FRACTION_TYPE);
      fractionObj = drawOneSymText(fractionStr, symFont, 
                    fractionStr.length,typeCode);
    }
    if (db.curProb.fracState == STATE_IN_GRID_FRACTION_NUM) {
      db.curLine.sym[db.curLine.sIndex].fractionNum = fractionObj;
    }
    else {
      db.curLine.sym[db.curLine.sIndex].fractionDen = fractionObj;
  }

  return(fractionStr);
    
}
   

/***
 * function moveOverGridText moves part of a line of text over one space
 * a positive gridW moves the line right for an insert
 * a negative gridw moves the line left for a delete
 * symbols are moved started with the symbol indicated by sIndex up until optional parameter end
 * Note this function may be passed on sIndex 1 or 2 creater than db.curLine.sIndex
 */
export function moveOverGridText(gridLine, sIndex, gridW, end, noLineMove) {
 
// if not passed an end parameter, then use the line length
  if (end == null) {
    end = gridLine.sym.length-1;
  }

  // positive gridW, move to right, counting up from sIndex
  if (end > sIndex) { 
    for (let i = sIndex; i <= end; i++) {
      // check for embedded text symbols and handle them differently
      if (gridLine.sym[i].type == symConst.KEY_ID_ABC) {
        gridLine.sym[i].container.x += gridW;
      }
      else {
        // Skip any empty symbol objects since they have undefined areas and also aren't displayed
        if (gridLine.sym[i].str != symConst.CV_EMPTY_SYM) {
          gridLine.sym[i].displayText.x += gridW;
          if (gridLine.sym[i].crossOff != null) {
            gridLine.sym[i].crossOff.x += gridW;
          }
          if (gridLine.sym[i].fractionNum != null) {
            gridLine.sym[i].fractionNum.x += gridW;
          }
          if (gridLine.sym[i].fractionDen != null) {
            gridLine.sym[i].fractionDen.x += gridW;
          }
        }
      }
      // move any line segments and line segment dots
      if (gridLine.sym[i].lineSeg != null) {
        gridLine.sym[i].lineSeg.x += gridW;
      }
      if (gridLine.sym[i].lineSegStart != null) {
        gridLine.sym[i].lineSegStart.x += gridW;
      }
      if (gridLine.sym[i].lineSegEnd != null) {
        gridLine.sym[i].lineSegEnd.x += gridW;
      }
    }
  }
  // negative gridW, move to left, counting down from sIndex
  else {
    for (let i = end; i <= sIndex; i++) {
      if (gridLine.sym[i].type == symConst.KEY_ID_ABC) {
        gridLine.sym[i].container.x += gridW;
      }
      else {
        // Skip any empty symbol objects since they have undefined areas and also aren't displayed
        if (gridLine.sym[i].str != symConst.CV_EMPTY_SYM) {
          gridLine.sym[i].displayText.x += gridW;
          if (gridLine.sym[i].crossOff != null) {
            gridLine.sym[i].crossOff.x += gridW;
          }
          if (gridLine.sym[i].fractionNum != null) {
            gridLine.sym[i].fractionNum.x += gridW;
          }
          if (gridLine.sym[i].fractionDen != null) {
            gridLine.sym[i].fractionDen.x += gridW;
          }
        }
      }
      // move any line segments and line segment dots
      if (gridLine.sym[i].lineSeg != null) {
        gridLine.sym[i].lineSeg.x += gridW;
      }
      if (gridLine.sym[i].lineSegStart != null) {
        gridLine.sym[i].lineSegStart.x += gridW;
      }
      if (gridLine.sym[i].lineSegEnd != null) {
        gridLine.sym[i].lineSegEnd.x += gridW;
      }
    }

  }
 
  // Check for overlay symbols, and redraw them the right position to match the move 
  for (let k = 0; k < gridLine.overlayDiv.length;  k++) {
    moveOverOverlay(gridLine.overlayDiv[k],sIndex, gridW, end) 
  }
 // if (!noLineMove && gridLine.overlayLine != null) {
 //   moveOverOverlay(gridLine.overlayLine,sIndex, gridW, end) 
  //  doStageUpdate();
 // }
}

function moveOverOverlay(overlay,sIndex, gridW, end) {

  //console.log("moveOverOverlay");

  // if sIndex is to the left of the whole overlay, then move the whole overlay over
  if (sIndex < overlay.start || (overlay.start == 0 && sIndex < 1) ||
      sIndex == overlay.start && gridW > 0) {
    //gridLine.overlay.container.x += db.curProb.gridW;
    overlay.start = (gridW > 0) ? overlay.start+1 : overlay.start-1 ;
    overlay.end = (gridW > 0) ? overlay.end+1 : overlay.end-1 ;
    drawUpdatedOverlay(overlay,true);    // this redraws overlay - line or long divide symbol
  }
  // if sIndex is in the middle of the overlay, then make the overlay longer
  else if (sIndex < overlay.end) {
    overlay.end = (gridW > 0) ? overlay.end+1: overlay.end-1;
    drawUpdatedOverlay(overlay,true);
  }
}


/***
 * function moveYGridText moves a set of lines of grid problem up or down vertically
 * a positive gridH moves the line down for an insert
 * a negative gridw moves the line up for a delete
 * startLIndex and endLIndex determine the lines to start and end the move 
 */
export function moveYGridText(mProb, endLIndex, gridH,startLIndex) {
 
  // go through each text createjs object and move it's y coordinate by one grid unit
  // If positive gridH move lines down
  if (gridH >0) {
    for (var i = endLIndex; i >= startLIndex ; i--) {
      for (var j = 0; j < mProb.line[i].sym.length; j++) {
        // empty null symbols don't have a createjs object of displayText so have to be skipped
        // to avoid runtime errors

        if (mProb.line[i].sym[j].type == symConst.KEY_ID_ABC) {
          mProb.line[i].sym[j].container.y += gridH;
        }
        else {
          if (mProb.line[i].sym[j].str != symConst.CV_EMPTY_SYM) {
              mProb.line[i].sym[j].displayText.y += gridH;

              // check for a cross-off symbol, and move it's createjs object if it exists 
              if (mProb.line[i].sym[j].crossOff != null) {
                mProb.line[i].sym[j].crossOff.y += gridH;
              }
              // check for grid fraction digits, and move if exists
              if (mProb.line[i].sym[j].fractionNum != null) {
                mProb.line[i].sym[j].fractionNum.y += gridH;
              }
              if (mProb.line[i].sym[j].fractionDen != null) {
                mProb.line[i].sym[j].fractionDen.y += gridH;
              }
            
          }
        }
        // move any line segments and line segment dots
        if (mProb.line[i].sym[j].lineSeg != null) {
          mProb.line[i].sym[j].lineSeg.y += gridH;
        }
        if (mProb.line[i].sym[j].lineSegStart != null) {
          mProb.line[i].sym[j].lineSegStart.y += gridH;
        }
        if (mProb.line[i].sym[j].lineSegEnd != null) {
          mProb.line[i].sym[j].lineSegEnd.y += gridH;
        }



      }
      // check for a line segment or divide overlay symbol, and move it's createjs object
     // if (mProb.line[i].overlayLine != null) {
      //  mProb.line[i].overlayLine.container.y += gridH;
      //  mProb.line[i].overlayLine.lIndex++;

      //}
      for (let k = 0; k < mProb.line[i].overlayDiv.length; k++) {
        mProb.line[i].overlayDiv[k].container.y += gridH;
        mProb.line[i].overlayDiv[k].lIndex++;
      }
         
    }
  }
  // if negative gridH do the same thing, but move lines up
  else {
    for (var i = startLIndex; i < endLIndex; i++) {
      for (var j = 0; j < mProb.line[i].sym.length; j++) {

        if (mProb.line[i].sym[j].type == symConst.KEY_ID_ABC) {
          mProb.line[i].sym[j].container.y += gridH;
        }
        
        else {
          if (mProb.line[i].sym[j].displayText != null) {//        str != symConst.CV_EMPTY_SYM) {
            mProb.line[i].sym[j].displayText.y += gridH;
            // check for a cross-off symbol 
            if (mProb.line[i].sym[j].crossOff != null) {
              mProb.line[i].sym[j].crossOff.y += gridH;
            }
            if (mProb.line[i].sym[j].fractionNum != null) {
              mProb.line[i].sym[j].fractionNum.y += gridH;
            }
            if (mProb.line[i].sym[j].fractionDen != null) {
              mProb.line[i].sym[j].fractionDen.y += gridH;
            }
          }
        }

        // move any line segments and line segment dots
        if (mProb.line[i].sym[j].lineSeg != null) {
          mProb.line[i].sym[j].lineSeg.y += gridH;
        }
        if (mProb.line[i].sym[j].lineSegStart != null) {
          mProb.line[i].sym[j].lineSegStart.y += gridH;
        }
        if (mProb.line[i].sym[j].lineSegEnd != null) {
          mProb.line[i].sym[j].lineSegEnd.y += gridH;
        }
      }
      // check for a line segment or divide overlay symbol, and move it's createjs object
      // change both .y and lIndex, but y is reset if overlay line gets redrawn, y changes it now
      //if (mProb.line[i].overlayLine != null) {
      //  mProb.line[i].overlayLine.container.y += gridH;
     //   mProb.line[i].overlayLine.lIndex--;
      //}
      for (let k = 0; k < mProb.line[i].overlayDiv.length; k++) {
        mProb.line[i].overlayDiv[k].container.y += gridH;
        mProb.line[i].overlayDiv[k].lIndex--;
          
      }
         
      
    }
  }  
  doStageUpdate();
}

/**
 * trimGrid will remove any blank rows or columns on outside of a grid problem
 * called when user clicks off an active problem to another one
 */
export function trimGrid() {

  let prob = db.curProb;
  let isBlank = true;
  let templIndex = db.curProb.lIndex;
  let trimmed = false;
  let topBlank = -1;
  let botBlank = prob.line.length;
  let len;
  let saveState = db.state;
  let stopTrim = false;
  db.state = STATE_OPEN_FILE; // set it to file open state to prevent extra createjs drawing, then set back;

  //console.log(prob);

  //db.state = STATE_FILE_OPEN;
  isBlank = true;
  // find any blank lines from bottom of problem
  for (let i = prob.line.length-1; i >= 0 && isBlank; i--) {
    // check for divide overlays
    
    if (prob.line[i].overlayDiv.length == 0  && (i== 0 || prob.line[i-1].overlayLine == null)) {
      len = prob.line[i].sym.length;
      // check for completely blank lines
      if (len > 0) {
        // otherwise check if each symbol empty or space
        for (let j = 0; j <= prob.line[i].sym.length-1 && isBlank; j++) {
          isBlank = ((prob.line[i].sym[j].str == symConst.CV_EMPTY_SYM || 
                     (prob.line[i].sym[j].str == symConst.KEY_ID_SPACE &&
                      prob.line[i].sym[j].crossOff == null)) &&
                     prob.line[i].sym[j].lineSeg == null);
        }
      }
   
      if (isBlank)  {
        if (prob.line.length ==1) {
          stopTrim = true;
       }
       else {
          db.curProb.lIndex = i;
          deleteLine();
          trimmed = true;
        }
      }
    }
    else {  // found an overlay
      isBlank = false;
    }
  }

  isBlank = true;
  

  let safetyIndex = 100;  // set just in case some oddd error happens to guarentee no infinite loop
  // find any blank lines from top of problem, and also no divide overlays
  while (isBlank && !stopTrim && prob.line.length > 0 && safetyIndex-- > 0 && 
          prob.line[0].overlayDiv.length == 0 && prob.line[0].overlayLine == null) {
    //console.log(prob.line[0].overlayDiv.length);
    len = prob.line[0].sym.length;
    if (len > 0) {
      for (let j = 0; j <= prob.line[0].sym.length-1 && isBlank; j++) {
        isBlank = ((prob.line[0].sym[j].str == symConst.CV_EMPTY_SYM || 
                    (prob.line[0].sym[j].str == symConst.KEY_ID_SPACE &&
                    prob.line[0].sym[j].crossOff == null)) &&
                    prob.line[0].sym[j].lineSeg == null);
      }
    }
    if (isBlank && prob.line.length > 1) {
      // check for divide overlays, which would make it not blank also
        db.curProb.lIndex = 0;
        deleteLine();
        trimmed = true;
    }
  }
  
  // check for columns to trim at the start of the problem
  isBlank = true;
  safetyIndex = 100;  
  let tempIndex;
  while (isBlank && !stopTrim && prob.width > 0 && safetyIndex-- > 0) { //} && 
    for (let j = 0; j <= prob.line.length-1 && isBlank; j++) {
      isBlank = ((prob.line[j].sym[0].str == symConst.CV_EMPTY_SYM || 
                  (prob.line[j].sym[0].str == symConst.KEY_ID_SPACE &&
                  prob.line[j].sym[0].crossOff == null)) &&
                  prob.line[j].sym[0].lineSeg == null &&
                (prob.line[j].overlayDiv.length == 0 || prob.line[j].overlayDiv[0].start > 0));
      if (prob.line[j].overlayDiv.length > 0) {
        //console.log(prob.line[j].overlayDiv[0].start,isBlank,prob.line[j].overlayDiv.length);
      }
    }

    // for blank columns, that also don't have a divide in the first column
    if (isBlank) {
      trimmed = true;
      // if found a blank column, delete each first symbol for each line
      for (let j = 0; j <= prob.line.length-1; j++) {
       
        tempIndex = prob.line[j].sIndex;
        prob.line[j].sIndex = -1;
        db.curLine = prob.line[j];
        cvControl(symConst.CV_CNTL_DELETE);
        prob.line[j].sIndex = Math.max(tempIndex-1,-1);
      }
      // move container over, so that the problem doesn't move from a gridTrim
      db.curProb.container.x += db.curProb.gridW*db.curProb.probScale;
      db.curProb.xpos += db.curProb.gridW*db.curProb.probScale;
    }
  }

  // check for columns at right of problem
  isBlank = true;
  let rightTrim = false;
  let i = prob.width;
  while (isBlank && !stopTrim && --i > 0) { //} && 
    for (let j = 0; j <= prob.line.length-1 && isBlank; j++) {

      isBlank = ((prob.line[j].sym[i] == null ||
                  prob.line[j].sym[i].str == symConst.CV_EMPTY_SYM || 
                  (prob.line[j].sym[i].str == symConst.KEY_ID_SPACE &&
                    prob.line[j].sym[i].crossOff == null )));
        if (prob.line[j].sym[i] != null && isBlank) {
          isBlank = (prob.line[j].sym[i].lineSeg == null); 
        }                  
    }
    
      // for blank columns, that also don't have a divide in the first column
      let changeWidth = false;
      if (isBlank) {
        trimmed = true;
        rightTrim = true;
     
        // if found a blank column, delete each first symbol for each line
        for (let k = 0; k <= prob.line.length-1; k++) {
          //if (prob.line[j].overlayLine != null && prob.line[j].overlayLine.start == 0) {
          //     prob.line[j].overlayLine.end--;
          //}
          if (prob.line[k].sym[i] != null) {
            changeWidth = true;
            if (prob.line[k].sym[i].displayText != null) {
            db.curProb.container.removeChild(prob.line[k].sym[i].displayText);
            }
            if(prob.line[k].sIndex ==i ) {
              prob.line[k].sIndex--
            }
            prob.line[k].sym.pop();  
          }    
        }
  
    }
  }
  if (rightTrim) {
    let newWidth = 0;
    for (let i = 0; i <= prob.line.length-1 ; i++) {
      newWidth = Math.max(newWidth, prob.line[i].sym.length);
    }
    prob.width = newWidth;
  }
  //console.log(prob);

    // check for divide overlays
    //console.log(prob.line[i].overlayLine);
    //if (prob.line[i].overlayDiv.length == 0  && (i== 0 || prob.line[i-1].overlayLine == null)) {

  db.state = saveState;

  if (trimmed) {
    db.fileChanged = true;
    drawProbShapes(
      Math.max(db.curProb.width, 2),
      Math.max(db.curProb.line.length, 1));
    doStageUpdate();
  
  }
  
}

/***
 * function displaySpecialSymFileOpen is called only upon file open to create and draw 
 * overlay symbols and fraction symbols in a grid problem on the current line indicated by db.curProb.lIndex
 * NEEDS CHANGING - add - multiple division symbols in one line support
 */
export function displaySpecialSymFileOpen(symObj) {
  // check the overlay type, make an overlay object to add to this line in db.curLine,
  // and call drawUnselectOverlay to draw the overlay symbol
  //console.log("displaySpecialSymFile");
 
  switch (symObj.symType) {
    case OVERLAY_TYPE_LINE:
      if (db.probState != STATE_IN_PASTE) {
        makeNewLineSegment(db.curLine, db.curProb.lIndex,symObj.size1,symObj.size2);
      }
    break;
    case OVERLAY_TYPE_DIVIDE:
      db.curOverlay = new OverlayType(OVERLAY_TYPE_DIVIDE,symObj.size1,symObj.size2); 
      db.curOverlay.myProb = db.curProb;
      db.curOverlay.lIndex = db.curProb.lIndex;
      db.curLine.overlayDiv.push(db.curOverlay);
      drawUpdatedOverlay(db.curOverlay,false);   // this will draw the line at the start and end coordinates
    break;
    // for grid factions need to create a bunch of symbols
    case symConst.KEY_ID_FRACTION_GRID_SIGN: 

      draw(symConst.KEY_ID_FRACTION, symConst.CV_BRANCHING_GRP, symConst.CV_FRACTION_TYPE);
      db.curProb.fracState = STATE_IN_GRID_FRACTION_NUM;
      let symFont = getSymFont(symConst.KEY_ID_FRACTION_GRID_SIGN, symConst.CV_FRACTION_TYPE);
    
      db.curLine.sym[db.curLine.sIndex].fractionNumStr = symObj.value;
      db.curLine.sym[db.curLine.sIndex].fractionDenStr = symObj.value2;     
      db.curLine.sym[db.curLine.sIndex].fractionNum = drawOneSymText(db.curLine.sym[db.curLine.sIndex].fractionNumStr, symFont, 
                      db.curLine.sym[db.curLine.sIndex].fractionNumStr.length,symConst.CV_FRACTION_TYPE);
      db.curProb.fracState = STATE_IN_GRID_FRACTION_DEN;
      db.curLine.sym[db.curLine.sIndex].fractionDen = drawOneSymText(db.curLine.sym[db.curLine.sIndex].fractionDenStr, symFont, 
                      db.curLine.sym[db.curLine.sIndex].fractionDenStr.length,symConst.CV_FRACTION_TYPE);
      db.curProb.fracState = STATE_NORMAL;
      db.xpos += db.curProb.gridW;
      drawCursor(db.xpos-db.curProb.halfGW,db.ypos-db.curProb.halfGH);

    break;
    default:
    break;
  } 
}
/***
 * function newLineSymGrid creates the db structures for an overlay symbol and then
 * calls drawNewLineSym to draw it.
 */
/*
export function oldnewLineSymGrid(keyID) {
  
  db.curOverlay = new OverlayType(OVERLAY_TYPE_LINE,0,db.curProb.width);
  db.curOverlay.myProb = db.curProb;

  // if at the start of a problem line, then put the line segment on the prior line
  // to show up drawn above the most recent empty symbol line
  if (db.curLine.sIndex == -1 && db.curProb.lIndex > 0) {
    db.curOverlay.lIndex = db.curProb.lIndex-1;
    db.curProb.line[db.curProb.lIndex-1].overlayLine = db.curOverlay;
    db.curProb.line[db.curProb.lIndex-1].overlayLine.container = 
      drawNewLineSym(0, db.curProb.width*db.curProb.gridW,keyID,db.curOverlay);
  }
  // if not at the start of a new line, then put the line segment on top of the current line 
  // to show up drawn right below current line, 
  // then add a new line if at the end of the problem
  else {  
    db.curOverlay.lIndex = db.curProb.lIndex;
    db.curLine.overlayLine = db.curOverlay; 
    db.curLine.overlayLine.container = 
        drawNewLineSym(db.curOverlay.start * db.curProb.gridW, 
        db.curOverlay.end*db.curProb.gridW, keyID, db.curOverlay);
    // add a new line after the overlay if last line, in this case by calling cvControl with an enter symbol
    if (db.curProb.lIndex == db.curProb.line.length-1) {
      cvControl(symConst.CV_CNTL_ENTER);
    }
    
  }
}
*/
/**
 * 
 * revised new line segment to draw individual lines
 */


export function newLineSymGrid(keyID) {
  
 
  // if at the start of a problem line, then put the line segment on the prior line
  // to show up drawn above the most recent empty symbol line
  if (db.curLine.sIndex == -1 && db.curProb.lIndex > 0) {
    makeNewLineSegment(db.curProb.line[db.curProb.lIndex-1],db.curProb.lIndex-1);
 
  }
  // if not at the start of a new line, then put the line segment on top of the current line 
  // to show up drawn right below current line, 
  // then add a new line if at the end of the problem
  else {  
    // if at end of line, then make line the whole problem length, which is default if no extra arguments passes
    if (db.curLine.sIndex == db.curLine.sym.length-1) {
      makeNewLineSegment(db.curProb.line[db.curProb.lIndex],db.curProb.lIndex); //,db.curLine.sIndex+1,db.curLine.sym.length-1);
    }
    // else start the line at the current sIndex
    else {
      makeNewLineSegment(db.curProb.line[db.curProb.lIndex],db.curProb.lIndex,
                         db.curLine.sIndex+1,db.curLine.sym.length-1);
      
    }
    if (db.curProb.lIndex == db.curProb.line.length-1) {
      cvControl(symConst.CV_CNTL_ENTER);
    }
    
  }
  doStageUpdate();
}

/***
 * function newDivSymGrid creates the db structures for a new long division overlay symbol,
 * and calls drawnewLineSym which also draws division symbols
 */
export function newDivSymGrid(keyID) {
  
  let endDiv;
  if (db.curLine.sIndex+1 >= db.curLine.sym.length) {
    endDiv = db.curLine.sIndex+2;
  }
  else {
    endDiv = db.curLine.sym.length;
  }
  

  // check to make sure user didn't start a second divide in the same problem as has one already, if they did, then
  // first make prior one inactive the divide line drag, so as to not mess up db.curOverlay structure.
  if (db.curOverlay != null && db.curOverlay.myProb == db.curProb && db.curOverlay.type == OVERLAY_TYPE_DIVIDE) {
    drawUpdatedOverlay(db.curOverlay,false);
  }

  db.curOverlay = new OverlayType(OVERLAY_TYPE_DIVIDE,db.curLine.sIndex+1,endDiv);
  db.curOverlay.myProb = db.curProb;
  db.curOverlay.lIndex = db.curProb.lIndex;
  db.curLine.overlayDiv.push(db.curOverlay);
  
  // save a link to the overlay in a symbol, to allow for deletes. 
  // put it on whatever symbol is closest and available
  if ( db.curLine.sym[db.curLine.sIndex] != null) {
    db.curLine.sym[db.curLine.sIndex].overlay = db.curOverlay;
  } 
  else if (db.curLine.sym[db.curLine.sIndex+1] != null) {
      db.curLine.sym[db.curLine.sIndex+1].overlay = db.curOverlay;
  }
 
  db.curOverlay.container = 
        drawNewLineSym(db.curOverlay.start * db.curProb.gridW, 
        db.curOverlay.end*db.curProb.gridW, keyID, db.curOverlay);
        
  
}

/***
 * function newCrossOff determines if a new crossoff symbol should be followed by carry digits
 * and the associated db.state change, then
 * calls drawCrossOff to draw the symbol
 */
export function newCrossOff(keyID) {

  // check if over a null symbol, and if so change to a space symbol
  if (db.curLine.sym[db.curLine.sIndex+1].str == symConst.CV_EMPTY_SYM) {
    db.curLine.sym[db.curLine.sIndex+1].str = symConst.KEY_ID_SPACE;
    db.curLine.sym[db.curLine.sIndex+1].type = symConst.CV_NUM_TYPE;
    let symFont = getSymFont(symConst.KEY_ID_SPACE, symConst.CV_NUM_TYPE);
    let text = drawOneSymText(symConst.KEY_ID_SPACE, symFont, 1,symConst.CV_NUM_TYPE);
    db.curLine.sym[db.curLine.sIndex+1].displayText = text;
    
  }

  
  // check if need to set up for writting a carry symbol in the same grid
  if (keyID == symConst.KEY_ID_GRAY_CROSSOFF_2 || keyID == symConst.KEY_ID_BLUE_CROSSOFF_2 
      || keyID == symConst.KEY_ID_CROSSOFF_2 || keyID == symConst.KEY_ID_CROSSOFF_3) {
    db.curLine.sym[db.curLine.sIndex+1].crossOffAddComplete = true;
    db.probState = STATE_CARRY_SYM;
  }
  
  drawCrossOff(db.curLine.sym[db.curLine.sIndex+1],db.curLine.sIndex+1,db.curProb.lIndex, keyID);
  drawCursor(db.xpos-db.curProb.halfGW, db.ypos-db.curProb.halfGH);
}

/***
 * function newCarry creates symbol objects for carry digits in the grid with a crossOff symbol,
 * and calls drawCarryText to draw it
 */

export function newCarry(keyID) {
 
  let symFont = getSymFont(keyID, symConst.CV_NUM_TYPE,"true");
  drawCarryText(db.curLine.sym[db.curLine.sIndex+1], keyID, symFont, 'black'); 

}

/***
 * function setInsertOutsideGrid is called from the event handling routine handleGridSurroundClick after
 * the user clicks on the "surround" box that defines a row of grid boxes surrounding a grid problem.  
 * The surround box is behind the background box, so clicks only trigger this routine if around and not in
 * It is a complex routine that determines which grid box the user selected based on calculating positions, 
 * and then grows the grid size and problem by inserting columns and/or null symbols as needed into the 
 * current problem, and shifting the the other problems symbols' createjs coordinates 
 */
export function setInsertOutsideGrid(newX,newY) {

  if (db.state == STATE_IN_CLIPBOARD_SELECT)  {
    // call clear state with flags set to only clear clipboard
    clearProbState(false,true);
  }
 
  let offsetX = newX - db.curProb.container.x;      // measure distance from click x,y to start of problem
  let xIndex = Math.trunc(offsetX/db.curProb.gridW);  
  
  // figure out how many grid units across this is
  let offsetY = newY - db.curProb.ypos+db.curProb.halfGH;
  let yIndex = Math.trunc(offsetY/db.curProb.gridH);
  // figure out where the corners are, to ignore clicks there
  let yEdge = (offsetY < 0) || (yIndex > db.curProb.line.length-1);
  let corner = ((offsetX < 0 && yEdge) ||
                (xIndex >= db.curProb.width && yEdge));
  
  
    if (!corner) {

    // if user clicked in column to left of problem, need to insert a column
    if (offsetX < 0) {
        db.xpos = db.curProb.xpos - db.curProb.gridW;
        db.curProb.lIndex = yIndex;
        db.curLine = db.curProb.line[yIndex];  
        db.curLine.sIndex = -1; 
        insertProbStartColumn();
        
    }
    // if user clicked in row above problem, then need to insert row before problem
    else if (offsetY < 0) {
      db.curLine.sIndex = xIndex-1;
      insertTopGridRow();
    }
    // if the user clicked below the problem box,
    // insert a line and symbols up to the position clicked
 
    else if (yIndex >= db.curProb.line.length) {
      //db.curLine.sIndex = xIndex-1;
      
      //insertSymLine(db.curProb,db.curLine.sIndex,db.curProb.lIndex+1);
      insertSymLine(db.curProb,xIndex-1,yIndex);

      for (let j = 0; j < xIndex; j++) {
          db.curLine.sIndex = j;
          pushOneNullSym();
      }
     
    }
   // if the user clicked to the right of the problem
    else {
      //console.log("here in click outside to right", yIndex, xIndex, db.curLine.sym.length);
      db.curProb.lIndex = yIndex;
      db.curLine = db.curProb.line[yIndex];
      let startWidth = db.curProb.width;
      //console.log("in right of prob click", startWidth);
  
      for (let k = db.curLine.sym.length-1; k < xIndex; k++) {
        db.curLine.sIndex = k;
        //console.log("push null to ", k, db.curProb.width);
        pushOneNullSym();
    }
    if (xIndex > startWidth) {
      db.curProb.width = xIndex; 
      db.curLine.lineWidth = xIndex;
      drawProbShapes(Math.max(db.curProb.width+1,2),db.curProb.line.length);
      //console.log("CHECK",db.curLine.lineWidth, db.curProb.width,startWidth);
    }
   

    }
   
    db.xpos = xIndex*db.curProb.gridW + db.curProb.xpos;      // set the xpos, ypos to be the midpoint of this unit
    db.ypos = yIndex*db.curProb.gridH + db.curProb.ypos;
    //db.curLine = db.curProb.line[yIndex];     // TEST THIS
    //db.curProb.lIndex = yIndex;
    //db.curLine.sIndex = xIndex-1;
    drawCursor(db.xpos-db.curProb.halfGW,db.ypos-db.curProb.halfGH);
    doStageUpdate();

    let logInput = new CanvasInput("grid outside click", "x" + xIndex + "y" + yIndex);
    db.userLog.input.push(logInput);
  }


}


// not used anymore
function drawOneGridBox(color,width) {
  let grid = new createjs.Shape();         // make a box around the symbol
  //grid.graphics.beginFill("yellow");
  grid.graphics.setStrokeStyle(0.2).beginStroke(color); // .setStrokeDash([2,2]);
  grid.graphics.rect(0, 0, db.curProb.gridW, db.curProb.gridH); // needs changing to canvas.width, canvas.height, or constants
  grid.x = db.xpos - db.curContainer.x - db.curProb.gridW / 2; // fix half-grids! if use
  grid.y = db.ypos - db.curContainer.y - db.curProb.gridH / 2;
  db.curContainer.addChild(grid);
  doStageUpdate();
   return grid;
}


export function insertTopGridRow () {
  db.curContainer.y -= db.curProb.gridH;
  db.curProb.ypos -= db.curProb.gridH;
  // insert all thee lines down within the container
  moveYGridText(db.curProb, db.curProb.line.length-1, db.curProb.gridH,0);
  // first move the other problem elements down
  // inserting a null line above this on in db structure
  
 
  //let tempSIndex = db.curLine.sIndex;
  
  insertSymLine(db.curProb,db.curLine.sIndex,0);
 
  //for (let j = 0; j < db.curProb.width; j++) {
  for (let j = 0; j <= db.curLine.sIndex; j++) {
    //db.curLine.sIndex = j;
    pushOneNullSym();
  }
  db.ypos = db.curProb.ypos;
 
  //db.curLine.sIndex = tempSIndex;
}


export function insertProbStartColumn() {
  // splice in a new symbol object with a null symbol at the start of each line
  for (let i=0; i < db.curProb.line.length; i++) {
    let newSym = new SymbolSimple(symConst.CV_EMPTY_SYM, symConst.CV_EMPTY_SYM); // not sure what type to put here 
    db.curProb.line[i].sym.splice(0,0,newSym);
    moveOverGridText(db.curProb.line[i], 0, db.curProb.gridW); 
    //db.curProb.line[i].sIndex++;       // adjust sIndex due to position move
  }
  // check problem width
  // move the container coordinates left 1 square
  //db.xpos -= db.curProb.gridW;
  db.curProb.container.x -= db.curProb.gridW;
  db.curProb.xpos -= db.curProb.gridW;
  drawProbShapes(++db.curProb.width+1, db.curProb.line.length);
  
  doStageUpdate();
  // shift all the elements of the problem to the right one, to adjust for the container
  // location change.  This should keep them in the same physical place

}



export function pushOneNullSym() {
  let newSym = new SymbolSimple(symConst.CV_EMPTY_SYM, symConst.CV_EMPTY_SYM); // not sure what type to put here 
  // experiment
  /*
  db.curLine.lineWidth++;
  if (db.curProb.width < db.curLine.lineWidth) {
    db.curProb.width = db.curLine.lineWidth;
    console.log("adjust prob width for new null");
  } 
    */
  db.curLine.sym.push(newSym);
}

export function spliceOneNullSym(type) {
  let newSym = new SymbolSimple(symConst.CV_EMPTY_SYM, type); // not sure what type to put here 
  db.curLine.sym.splice(db.curLine.sIndex+1,0,newSym);
}


  
  // function handleDeleteFromGrid is called after the user clicks a delete key to delete one symbol
export function handleDeleteFromGrid(keyID) {
   
    let textToDelete;
    let probDel = false;
    let count = -1;
    let symIndex;

    // if have a backspace, then do nothing if at start of line, unless empty probem or text
    if (keyID == symConst.CV_CNTL_BACKSPACE && db.curLine.sIndex == -1 && 
        db.curProb.width > 0 && db.curProb.displayType != DISPLAY_TYPE_TEXT &&
        db.curLine.sym.length > 0) {
          return;
        }
   
    if (db.probState != STATE_NORMAL) {
      clearProbState();

    }

    // check if within a grid fraction that has digits, and if so, then don't
    // do delete here - instead pass to drawGridFracton since the fraction parts will have to be
    // redrawn and the symbol isn't deleted
   
    if (db.curProb.fracState != STATE_NORMAL && db.curLine.sIndex >= 0) {
       if ((db.curLine.sym[db.curLine.sIndex].fractionNumStr.length > 0) ||
        (db.curLine.sym[db.curLine.sIndex].fractionDenStr.length > 0)) {
        drawGridFraction(keyID,symConst.CV_NUM_TYPE,true);
        return;
        }
    }       
      
    // if get a delete key entry during an ipad ABC event (from the delete icon, then send it to the text handling routine
    // and exit routine here to make this routine cleaner otherwise
  
    // first check if it's a empty problem or last character in problem, 
    // or if it's a text problem that contains only one text element
    //if so then delete the problem
    // and set the current problem to the last in list
    if ((db.curProb.width < 1) || 
        (db.curProb.displayType == DISPLAY_TYPE_TEXT))  { //||
        //(db.curProb.width == 1 && db.curLine.sym.length <= 1 && db.curProb.line.length == 1)) {
        
      removeChildFromStage(db.curProb.container);    // remove createjs objects for this problem
      doStageUpdate();
      db.cursor = null;
      db.curProb.deleted = true;

      let nextPID = findNextPIndex(db.pIndex);
      
      let switchMode = checkLev3Mode(nextPID);
      if (switchMode) {
        db.displayType = switchMode;
      }
      
      db.pIndex = nextPID;

      if (db.pIndex == -1)  { // if deleted last problem put x,y back to start and return to init state
        db.xpos = START_XPOS;
        db.ypos = START_YPOS;
        db.state = STATE_INIT;
        db.curProb = null;
        db.curContainer = null;
        db.curLine = null;
      }
      else {  // else set up current problem to the last problem and last problems positions
        makeProbSelected(db.pIndex);
        
        drawCursor(findProbEndX(db.curProb)+db.curProb.xpos-db.curProb.halfGW, 
                  findProbEndY(db.curProb)+db.curProb.ypos-db.curProb.halfGH);
      }
    
      if (switchMode) {
        notifySideboardLev3Mode(switchMode);
      }
    } 

    // manage delete symbol from within problem
    else {  
      symIndex = db.curLine.sIndex;
      
      // if this was first symbol of line then delete that line instead of a symbol
      // also delete line segment if exists from prior line
      if (db.curLine.sym.length === 0) {456
        deleteLine();
      } 

      // otherwise find symbol to delete
      else {
       
        // check if are deleting from middle or end of line
        if (symIndex >= db.curLine.sym.length-1) {
          // delete the prior text sym if at end of problem (do backspace in this case)
        
          // check if user just selected a position without a symbol past the line length
          // in this case just move the cursor left (case to safeguard against error in unexpected situations)
        
          if (db.curLine.sym[symIndex] == null) {
            if (db.curLine.sIndex > -1) {
              console.log("found delete error - empty symbol",db.curLine);
              db.curLine.sIndex--;
              db.xpos -= db.curProb.gridW;
            }
          }
          else { 
            if (db.curLine.sym[symIndex].crossOff != null) {
              db.curProb.container.removeChild(db.curLine.sym[symIndex].crossOff);
            }

            // check if there is a long division starting at this symbols, and delete it if so
            if (db.curLine.sym[symIndex].overlay != null) {
    
              for (let k = 0; k < db.curLine.overlayDiv.length; k++ ) {
                if (db.curLine.overlayDiv[k] == db.curLine.sym[symIndex].overlay) 
                    db.curLine.overlayDiv.splice(k,1);
                
              }
     
              let result = db.curProb.container.removeChild(db.curLine.sym[symIndex].overlay.container);
              db.curLine.sym[symIndex].overlay = null;

            }
            let notABC = checkDeleteABC(symIndex);

            if (notABC) {
              // check if need to adjust a divide overlay
              //if (db.curLine.overlayDiv != null) {
             
              //  moveOverOverlay(db.curLine.overlayDiv[0], db.curProb.sIndex, -db.curProb.gridW)
              //}
              deleteLineSegs(db.curLine,symIndex);

              // remove fractions also if exist
              if (db.curLine.sym[symIndex].fractionNum != null) {
                db.curProb.container.removeChild(db.curLine.sym[symIndex].fractionNum);
              }
              if (db.curLine.sym[symIndex].fractionDen != null) {
                db.curProb.container.removeChild(db.curLine.sym[symIndex].fractionDen);
              }

              textToDelete = db.curLine.sym[symIndex].displayText; 
             
              db.curLine.sym.pop();  
              db.curProb.container.removeChild(textToDelete);
              db.curLine.sIndex--;
              symIndex--;
              db.xpos -= db.curProb.gridW;
            }
          }
          
        }
        // otherwise check if user pressed backspace or whether it is delete/erasor
        // if delete/erasor then Delete the next symbol after symIndex, not symIndex one that is before it 
        // if backspace then delete the symbol at symIndex
        else {
          if (keyID == symConst.CV_CNTL_DELETE) {
              symIndex++;
          }
          if (db.curLine.sym[symIndex].crossOff != null) {
            db.curProb.container.removeChild(db.curLine.sym[symIndex].crossOff);
          }
     
          let notABC = checkDeleteABC(symIndex);
          if (notABC) {

            //remove any line segment and move and line segment starts
            deleteLineSegs(db.curLine,symIndex);

            textToDelete = db.curLine.sym[symIndex].displayText;
            db.curProb.container.removeChild(textToDelete); 

           
            // remove fractions also if exist
            if (db.curLine.sym[symIndex].fractionNum != null) {
              db.curProb.container.removeChild(db.curLine.sym[symIndex].fractionNum);
            }
            if (db.curLine.sym[symIndex].fractionDen != null) {
              db.curProb.container.removeChild(db.curLine.sym[symIndex].fractionDen);
            }
            db.curLine.sym.splice((symIndex),1); 
            
            // if not the last symbol in line, then move symbols after this one to right 
            // pass a false last parameter to indicate not ot move any overlay line on delete 
            if (symIndex <= db.curLine.sym.length-1) { 
              moveOverGridText(db.curLine, symIndex, -db.curProb.gridW,null,false); 

            }
            if (keyID == symConst.CV_CNTL_BACKSPACE) {
              db.curLine.sIndex--;
              db.xpos -= db.curProb.gridW;
            }
          }
          
        }
    
      }
      
  
      // redraw the grid shape based on updated problem size, with a minimum width of 2 grid units and 1 line
      // check if the last line is the longest, and if so then leave extra blank column on empty grid
      // otherwise don't size next symbol to draw would still be within grid
  
      if (!probDel) { 
        let tempWidth = symIndex - 1;
        for (let i = 0; i < db.curProb.line.length; i++) {
          tempWidth = Math.max(tempWidth, db.curProb.line[i].sym.length);
        }
        db.curProb.width = tempWidth; 
       // if current line is longest then draw an extra column at end
        if (db.curProb.width == db.curLine.sym.length) {
          tempWidth = 1;
        } else {
          tempWidth = 0;
        }
        drawProbShapes(
          Math.max(db.curProb.width + tempWidth, 2),
          Math.max(db.curProb.line.length, 1));
        // redraw the cursor at the updated position
        drawCursor(db.xpos-db.curProb.halfGW,db.ypos-db.curProb.halfGH);
      }
    //console.log("done delete", db.curLine);
    doStageUpdate();
 
    }
  }

// delete the line segment fields in a symbol
function deleteLineSegs(line,index) {

//console.log("start seg delete");
  //remove any ling segment and move and line segment starts
  if (line.sym[index] != null) {
    db.curProb.container.removeChild(line.sym[index].lineSeg);
    db.curProb.container.removeChild(line.sym[index].lineSeg = null);
    if (line.sym[index].lineSegStart != null &&
        line.sym[index].lineSegEnd != null) {
        line.sym[index].lineSegStart.removeAllEventListeners();
        db.curProb.container.removeChild(line.sym[index].lineSegStart);
        line.sym[index].lineSegEnd.removeAllEventListeners();
        db.curProb.container.removeChild(line.sym[index].lineSegEnd);
        //console.log("both");
    }
    else {
                
      if (line.sym[index].lineSegStart != null) 
        if  (line.sym[index+1] != null) {
          
          line.sym[index+1].lineSegStart = line.sym[index].lineSegStart;
          // this does get moved in moveover since to the right of delete, however shouldn't be,
          // so change x up a grid to end up at the right place
          line.sym[index+1].lineSegStart.x += db.curProb.gridW*db.curProb.probScale;
        }
        else {
            line.sym[index].lineSegStart.removeAllEventListeners();
            db.curProb.container.removeChild(line.sym[index].lineSegStart);
        }
      if (line.sym[index].lineSegEnd != null) {
        
        if (line.sym[index-1] != null) {
          line.sym[index-1].lineSegEnd = line.sym[index].lineSegEnd;
          // this doesn't get moved in moveover since to the left of the delete
           line.sym[index-1].lineSegEnd.x -= db.curProb.gridW*db.curProb.probScale;
        }
        else {
          line.sym[index].lineSegEnd.removeAllEventListeners();
          db.curProb.container.removeChild(line.sym[index].lineSegEnd);
        }
      }
    } 
  }
}
/****
 * 
 * function deleteLine deletes the line at db.curProb.lIndex, and also any overlayLine on the 
 * prior line, and moves up any later lines in the display
 */
 function deleteLine() {

  // check first if there is a line overlay on prior line, and delete if so
  if (db.curProb.lIndex > 0 && db.curProb.line[db.curProb.lIndex-1].overlayLine != null) {
    db.curProb.container.removeChild(db.curProb.line[db.curProb.lIndex-1].overlayLine.container);
    db.curProb.line[db.curProb.lIndex-1].overlayLine = null;
    doStageUpdate();
  }
   
  // move up any lines after this one
  moveYGridText(db.curProb,db.curProb.line.length,-db.curProb.gridH, db.curProb.lIndex);
  // remove this line from line array in this problem
  db.curProb.line.splice(db.curProb.lIndex,1); 
  //console.log(db.curProb.line.length);

  // If this wasn't the first line of the problem, then set the curline to the line prior
  if (db.curProb.lIndex > 0) {
    db.curLine = db.curProb.line[--db.curProb.lIndex];
    db.ypos -= db.curProb.gridH;
    db.xpos = db.curProb.xpos + db.curLine.sym.length * db.curProb.gridW;
  } 
  else  { 
    // next check if first line was deleted but there are other lines
    // if so then the later line has become the first, and move the problem container down
    if (db.curProb.line.length > 0) {  
      db.curLine = db.curProb.line[db.curProb.lIndex]; 
      db.curLine.sIndex = -1;
      db.curProb.container.y += db.curProb.gridH;
      db.curProb.ypos += db.curProb.gridH;
      db.ypos += db.curProb.gridH;
      //moveYGridText(db.curProb, db.curProb.lIndex, -db.curProb.gridH,0);
    }
    else {
      // otherwise delete problem if this was the last symbol in the problem
      // by marking it deleted and removing from stage
      // problems aren't removed from db structure since that would make pindexes
      // out of sync with background boxes for problem drags
      deleteProb();
     
    }
  }
  //console.log(db.curProb.line.length,db.curProb);

 }
/***
 * function checkDeleteABC figures out if the current delete request is over an embedded text box
 * and if so deletes the text box and associated fill symbols
 */
function checkDeleteABC(sIndex) {
  
   let count = -1;
   let count2 = 0;
   let notABC = true;

   // look for symbol types that indicate text or fill
   if (db.curLine.sym[sIndex].type == symConst.CV_TEXT_FILL ) {
    count = sIndex;
    while (db.curLine.sym[count].type != symConst.KEY_ID_ABC && count >= 0) {
      count--;
    }
    count = (count >=0) ? count : -1 ; 
  }
  else if (db.curLine.sym[sIndex].type == symConst.KEY_ID_ABC) {
    count = sIndex;
  } 

  // if found text symbol, then remove that text createjs object and splice out
  // the text and fill symbol objects from the current line
  if (count >=0) {
    notABC = false;
    db.curProb.container.removeChild(db.curLine.sym[count].container);  
    let i = count; 
    
    while (db.curLine.sym[i] != null && 
          (db.curLine.sym[i].type == symConst.KEY_ID_ABC ||
          db.curLine.sym[i].type == symConst.CV_TEXT_FILL)) {
            
        count2++; 
        db.curLine.sym.splice(i,1);
    }

    db.xpos = db.curProb.xpos + Math.max(0,db.curProb.gridW*(count));
    db.curLine.sIndex = count-1;
    if (i < db.curLine.sym.length) {
      moveOverGridText(db.curLine, count, -db.curProb.gridW*count2);  
    }
    drawCursor(db.xpos-db.curProb.halfGW, db.ypos-db.curProb.halfGH);
  }  
 
  // return false if found text symbol
  return(notABC); 
}

